import { useMutation } from "react-query";
import nonUserService from "../../services/nonUserService";

const useAddAnonymousAction = () => {
    return useMutation((formData) => nonUserService.addAction(formData));
}

export default useAddAnonymousAction;
